import { styled } from '@mui/material';

export const StyledUsheIcon = styled('span')({
  display: 'inline-flex',
  flexShrink: 0,

  '& > img': {
    display: 'block',
  },
});
